"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

const REVEAL_SELECTOR = "[data-reveal]";

export function RevealObserver() {
  const pathname = usePathname();

  useEffect(() => {
    const root = document.documentElement;

    root.dataset.uiReady = "true";

    const elements = Array.from(
      document.querySelectorAll<HTMLElement>(REVEAL_SELECTOR),
    );

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      elements.forEach((element) => {
        element.dataset.revealState = "visible";
      });
      return;
    }

    root.dataset.motion = "enhanced";

    if (!elements.length) {
      return;
    }

    const isMobileViewport = window.matchMedia("(max-width: 767px)").matches;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.setAttribute("data-reveal-state", "visible");
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: isMobileViewport ? 0.08 : 0.22,
        rootMargin: isMobileViewport ? "0px 0px 6% 0px" : "0px 0px -10% 0px",
      },
    );

    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      const initialRevealOffset = isMobileViewport ? 1.08 : 0.9;
      const isInitiallyVisible = rect.top <= viewportHeight * initialRevealOffset;

      element.dataset.revealState = isInitiallyVisible ? "visible" : "pending";

      if (!isInitiallyVisible) {
        observer.observe(element);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [pathname]);

  return null;
}
